// Dropdown.js
import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import './styles/Dropdown.scss'

import {v4} from 'uuid'

import { Link } from 'react-router-dom'

const Dropdown = ({ options, currentProducts }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedOption, setSelectedOption] = useState(null)
    const [currentProduct, setCurrentProduct] = useState(undefined)

    // console.log(currentProduct)

    useEffect(() => {
        // Сбросить выбранную опцию при изменении текущих продуктов
        setSelectedOption(null)
    }, [currentProducts])

    const handleToggle = () => {
        setIsOpen(!isOpen)
    }

    const handleOptionClick = (option) => {
        setSelectedOption(option)
        setIsOpen(false)

        const selectedProduct = currentProducts.find((product) => product['productName' || 'product-name'] === option)

        setCurrentProduct(selectedProduct)
    }

    return (
        <div className="dropdown-container__outer">
            <div className="dropdown-container">
                <div className="dropdown-header" onClick={handleToggle}>
                    {selectedOption ? selectedOption : 'Выберите опцию'}
                </div>

                <AnimatePresence>
                    {isOpen && (
                        <motion.ul
                            className="dropdown-list"
                            initial={{ opacity: 0, scaleY: 0 }}
                            animate={{ opacity: 1, scaleY: 1 }}
                            exit={{ opacity: 0, scaleY: 0 }}
                        >
                            {options.map((option) => (
                                <motion.li key={v4()} onClick={() => handleOptionClick(option)} whileHover={{ scale: 1 }}>
                                    {option}
                                </motion.li>
                            ))}
                        </motion.ul>
                    )}
                </AnimatePresence>
            </div>

            {currentProduct && selectedOption ? (
                <div className="dropdown-info">
                    <p className='main-text main-text--bold'>{currentProduct.info.text}</p>
                    <br />
                    <p>{currentProduct.info.additionalText}</p>
                    <br />
                    <div>
                        <Link className="btn" to={`/product/${currentProduct.id}`}>
                            Смотреть подробнее
                        </Link>
                    </div>
                </div>
            ) : (
                ''
            )}
        </div>
    )
}

export default Dropdown
